window.addEventListener('load', function () {
    if (document.querySelectorAll('.nextGames').length) {
        const elements = document.querySelectorAll('.nextGames');

        elements.forEach(function (element) {
            const buttons = element.querySelectorAll(".filterCategory button");
            const boxes = element.querySelectorAll(".box");

            // 1. Aktiviere den ersten Button standardmäßig
            if (buttons.length > 0) {
                buttons.forEach(btn => btn.classList.remove("active"));
                buttons[0].classList.add("active");

                // Zeige nur Boxen der ersten Kategorie
                const firstCategory = buttons[0].getAttribute("data-category");
                boxes.forEach(box => {
                    if (box.classList.contains(firstCategory)) {
                        box.classList.add("active");
                        box.style.display = "grid";
                    } else {
                        box.classList.remove("active");
                        box.style.display = "none";
                    }
                });
            }


            buttons.forEach(button => {
                button.addEventListener("click", () => {
                    const category = button.getAttribute("data-category");

                    buttons.forEach(btn => btn.classList.remove("active"));
                    button.classList.add("active");

                    boxes.forEach(box => {
                        if (box.classList.contains(category)) {
                            box.classList.add("active");
                            box.style.display = "grid";
                        } else {
                            box.classList.remove("active");
                            box.style.display = "none";
                        }
                    });
                });
            });
        });
    }
});
